import Axios from 'axios';



export default {

    getAll() {
        const BASE_URL =  '/public/api';
        return Axios.get(BASE_URL + '/transactions')
    },
    create(data) {
        const BASE_URL =  '/public/api';
        return Axios.post(BASE_URL + '/transactions', data);
    },

    update(id, data) {
        const BASE_URL =  '/public/api';
        return Axios.put(BASE_URL + '/transactions/' + id, data);
    },

    delete(id) {
        const BASE_URL =  '/public/api';
        return Axios.delete(BASE_URL + '/transactions/' + id);
    },
    allSaleItems() {
        const BASE_URL =  '/public/api';
        return Axios.delete(BASE_URL + '/all_trans_items');
    },
    getSalesRpt(data){
        const BASE_URL =  '/public/api';
        return Axios.post(BASE_URL + '/reports', data);
    }

}